// One note per visit. The BlinkScribe backend auto-combines a new recording
// or upload into the appointment's existing note when that note is
// (post_recording.py AUTO-COMBINE and the two streaming finalizers):
//   - on the same appointment,
//   - transcriptionstatus 'Summarized',
//   - recording_type 'original' or 'combine',
//   - DATE(ts) = CURDATE() in MySQL, whose time zone is America/Chicago,
// and it picks the newest such row (ORDER BY id DESC). The UI uses the same
// rule to decide whether to offer "Add to today's note".
//
// recording `ts` comes back from /v1/patient/{pid}/recording/details as a
// naive server-local ISO string ("2026-09-28T03:52:24"), so its first ten
// characters are already the server's calendar date.

export const SERVER_TIME_ZONE = "America/Chicago";

// Today's date (YYYY-MM-DD) on the server's calendar, whatever the browser's
// own time zone is.
export function serverDateString(now = new Date(), timeZone = SERVER_TIME_ZONE) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const get = (type) => parts.find((p) => p.type === type)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

// The row a new recording on `appointmentid` would be combined into, or null.
export function findSameDayNote(recordings, appointmentid, now = new Date()) {
  if (!Array.isArray(recordings) || appointmentid === undefined || appointmentid === null || appointmentid === "") {
    return null;
  }
  const today = serverDateString(now);
  let newest = null;
  for (const row of recordings) {
    if (!row || String(row.appointmentid) !== String(appointmentid)) continue;
    if (row.transcriptionstatus !== "Summarized") continue;
    const type = row.recording_type || "original";
    if (type !== "original" && type !== "combine") continue;
    if (typeof row.ts !== "string" || row.ts.slice(0, 10) !== today) continue;
    if (!newest || Number(row.id) > Number(newest.id)) newest = row;
  }
  return newest;
}
